import React from 'react';
import { PageSection } from '../PageSection';
import { CheckItem } from '../CheckItem';
import { FlowSteps } from '../FlowSteps';
import { volumes } from '../../data/volumes';
export function VolumesSection() {
  return <PageSection label="Los 10 volúmenes" className="bg-carbon-900" data-id="element-212" data-mp="2mtvgr13ueto5">
      <div className="space-y-6" data-id="element-213" data-mp="2rtq815rj5l9q">
        {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-xl border border-carbon-800 bg-carbon-950" data-id="element-214" data-mp="2rs5ar8dtzo86">
            <div className="p-6 md:p-8" data-id="element-215" data-mp="2e0ie37fz8dov">
              <p className="inline-block rounded bg-accent-500 px-2.5 py-0.5 font-display text-sm font-extrabold uppercase tracking-[0.15em] text-carbon-950" data-id="element-216" data-mp="2itjvbm3nopbm">
                Volumen {v.number}
              </p>
              <h3 className="mt-3 text-3xl font-extrabold uppercase leading-[1.05] text-white md:text-[2.1rem]" data-id="element-217" data-mp="294jv5zdf3nvu">{v.title}</h3>
              <p className="mt-3 text-lg font-semibold leading-snug text-carbon-100" data-id="element-218" data-mp="1v4iuajx5kggd">{v.headline}</p>
              <p className="mt-6 text-sm font-semibold text-carbon-300 md:text-base" data-id="element-219" data-mp="1z4j6rz0oyhks">Incluye:</p>
              <ul className="mt-3 grid gap-x-6 gap-y-2.5 text-base text-carbon-200 sm:grid-cols-2" data-id="element-220" data-mp="1fhfdol9q337k">
                {v.list.map(item => <CheckItem key={item} data-id="element-221" data-mp="1amjkhhsr29sv">{item}</CheckItem>)}
              </ul>
            </div>
            <div className="border-t border-carbon-800 bg-carbon-900 px-6 py-4 md:px-8" data-id="element-222" data-mp="1pfdavy9k8acb">
              <FlowSteps steps={v.flow} data-id="element-223" data-mp="1kj4obzt19ev4" />
            </div>
          </article>)}
      </div>
    </PageSection>;
}